import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
// import { DoadorList, Pagination } from './doador';
import { take } from 'rxjs/operators';
import { TecidoList, Pagination } from './tecido';


@Injectable({
    providedIn: 'root'
  })
  export class TecidosCaptadosService {
  private readonly API = `${environment.API}`
    constructor(protected http: HttpClient) { }

    findAll(limit: string, page: string, search: string): Observable<Pagination<TecidoList[]>> {
        let params = new HttpParams();
        params = params.append('page', page);
        params = params.append('size', limit);
        params = params.append('busca', search);
    
        return this.http.get<Pagination<TecidoList[]>>(`${this.API}tecido/listar`, { params: params })
          .pipe(
            take(1)
          );
      }
  
}
